var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = (_vm.info.amount / 100).toFixed(2)
  var g1 = (_vm.info.duration / 60).toFixed(1)
  var l0 = _vm.__map(_vm.info.memberRidesResponseList, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var g2 = (item.rideTime / 60).toFixed(1)
    var g3 = (item.duration / 60).toFixed(1)
    return {
      $orig: $orig,
      g2: g2,
      g3: g3,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }